export class DeviceInfo {
    public side: string;
    public brandId: number;
    public modelId: string;
    public pairingAddress: number;
    public couplingId: number;

    constructor(
        side: string,
        brandId: number,
        modelId: string,
        pairingAddress: number,
        couplingId: number
    ) {
        this.side = side;
        this.brandId = brandId;
        this.modelId = modelId;
        this.pairingAddress = pairingAddress;
        this.couplingId = couplingId;
    }
}
